import { useMemo } from 'react';

import { SmileyOutline } from '@lyearn/icons';
import { IconButton } from '@lyearn/ui';
import { ToolbarButtonProps } from '@/components/Editor/PlainEditor/types';
import ReactionSelector from '@/features/reactions/components/ReactionSelector';
import { REACTION_SELECTOR_OVERRIDES } from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/styles';
import getOnSelectReaction from '@/modules/corporate/modules/channel/views/ChannelDetails/hooks/useMessageInput/utils/getOnSelectReaction';

const AddEmojiOption: React.FC<ToolbarButtonProps> = ({ editorView }) => {
  const onSelectReaction = useMemo(() => getOnSelectReaction(editorView), [editorView]);

  return (
    <ReactionSelector
      overrides={REACTION_SELECTOR_OVERRIDES}
      tooltipPlacement="bottom"
      onSelect={onSelectReaction}>
      <IconButton
        Icon={SmileyOutline}
        appearance="secondary"
        className="me-4"
        shape="square"
        size="s"
        variant="ghost"
      />
    </ReactionSelector>
  );
};

export default AddEmojiOption;
